const dataAt = props => ({
	'data-at': props.dataAt
});

export default dataAt;
